import { NgModule } from '@angular/core';
import { AsCasesDynamiquesPipe, AsCheckboxPipe, AsCustomFieldPipe, AsDrawingPipe, AsFieldPipe, AsInputNumberPipe, AsInputTextPipe, AsLabelPipe/*, AsListUserPipe*/, AsListePipe, AsRadioPipe, AsTextAreaPipe,ReadonlyByRulePipe } from './as-pipes.pipe';


@NgModule({
  declarations: [
    AsLabelPipe,
    AsFieldPipe,
    AsCustomFieldPipe,
    AsCheckboxPipe,
    AsRadioPipe,
    AsTextAreaPipe,
    AsInputTextPipe,
    AsInputNumberPipe,
    AsDrawingPipe,
    AsCasesDynamiquesPipe,
    AsListePipe,
    ReadonlyByRulePipe,
    /*
    AsListUserPipe,
    */
  ],
  exports: [
    AsLabelPipe,
    AsFieldPipe,
    AsCustomFieldPipe,
    AsCheckboxPipe,
    AsRadioPipe,
    AsTextAreaPipe,
    AsInputTextPipe,
    AsInputNumberPipe,
    AsDrawingPipe,
    AsCasesDynamiquesPipe,
    AsListePipe,
    ReadonlyByRulePipe,
    /*
    AsListUserPipe,
    */
  ]
})
export class AsPipesModule { }
